module.exports = __webpack_public_path__ + "static/media/exhibition-services-img2.b2c750af.jpg";